import { API_AUTH } from "../common";

const PhiSanXuatApi = {
    getLichSuPhiSanXuat: (OrderID) =>
        API_AUTH.get(`QuanLyMuaBan/PhiSanXuat/GetLichSuPhiSanXuat?orderID=${OrderID}`),

    luuPhiSanXuat: (data) =>
        API_AUTH.post(`QuanLyMuaBan/PhiSanXuat/LuuPhiSanXuat`, data),

    xoaPhiSanXuat: (PhiSXID) =>
        API_AUTH.post(`QuanLyMuaBan/PhiSanXuat/XoaPhiSanXuat?phiSXID=${PhiSXID}`),
};


export default PhiSanXuatApi;